import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { useRef } from "react";
import { useState } from "react";

export default function Landing2Works() {

  const videoRef = useRef(null);
  // const [isPlaying, setIsPlaying] = useState(false);
  const [showButton, setShowButton] = useState(true);

  const handlePlay = () => {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.play();
        // setIsPlaying(true);
        setShowButton(false)
      } else {
        videoRef.current.pause();
        // setIsPlaying(false);
      }
    }
  };

  // const handleHover = () => {
  //   setShowButton(true); // Show button when hovering over the video
  // };

  // const handleMouseLeave = () => {
  //   if (isPlaying) {
  //     setShowButton(false); // Hide the button only if the video is playing
  //   }
  // };

  return (
    <>
      <section className="land2-works">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="land2-work-head text-center">
                <h3 className="heading gradiant-color">How It Works</h3>
                <label>Launch Your Transport Business in 3 Easy Steps.</label>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="land2-works-box">
                <img loading="lazy" src="/assets/home/land2-work-1.webp" alt="logo" className="img-responsive" />
                <div>
                  <h4>Tell Us About Your Brand</h4>
                  <p>Share your logo, color scheme, and essential business details.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="land2-works-box">
                <img loading="lazy" src="/assets/home/land2-work-2.webp" alt="logo" className="img-responsive" />
                <div>
                  <h4>We Set Everything Up</h4>
                  <p>Our team configures the apps, admin panel, and domain.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="land2-works-box">
                <img loading="lazy" src="/assets/home/land2-work-3.webp" alt="logo" className="img-responsive" />
                <div>
                  <h4>You Go Live!</h4>
                  <p>Start accepting bookings and managing operations effortlessly.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-12">
              <div 
        //       onMouseEnter={handleHover}
        // onMouseLeave={handleMouseLeave} 
        className="land2-work-video">
                <video ref={videoRef} src="/assets/home/land2-video.mp4" poster="/assets/home/land2-video-thumbnail.webp"></video>
             {showButton && (   <span onClick={handlePlay} className="animated-btn"><FontAwesomeIcon icon={faPlay} /></span>  )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
